const findUsedProducts = products => (
    products.filter(product => product.used)
 );
 
 export default findUsedProducts;